import './index.css'

import React from 'react'
import Drawer from "react-drag-drawer";
import LogoPng from '../../assets/images/new/logo-header.webp'

const DownloadAppModal = (props) => {
  return (
    <Drawer
      open={props.opened}
      direction="bottom"
      dontApplyListeners={false}
      onRequestClose={props.close}
      containerElementClass="px-6"
      modalElementClass="download-app-modal"
    >
      <div className="download-app-modal-content">
        <p className="title text-lg text-center font-bold">Use o aplicativo da Máquina de Contos para obter a melhor experiência</p>
        <p className="text-center text-white mt-2">Leia e ouça seus livros online e offline. Guarde-os na sua biblioteca</p>

        <a
          className="google-button"
          href='https://play.google.com/store/apps/details?id=br.com.gravioladigital.mdc'
          target='_blank'
        />

        <a
          href='https://apps.apple.com/br/app/dum-dum-livros/id6755551889'
          target='_blank'
          className="app-store-button"
        />

        <button onClick={props.close} className="w-52 h-10 mx-auto text-white bg-pallet-3 focus:ring-0 rounded-full px-5 py-2.5 mt-4 focus:outline-none font-bold hover:bg-pallet-8 text-sm">
          continuar no site
        </button>

        <img src={LogoPng} className="logo" />
      </div>
    </Drawer>
  )
}

export default DownloadAppModal